export const statics = {
  BaseUrl: 'https://api.greenfilter.com',
};

export const SHOPIFY_CONFIG = {
  domain: 'store.greenfilter.com',
  apiKey: 'b0f6e285934ab0374588e085bda31072',
  appId: '6',
  apiVersion: '2024-01',
};
